<template>
  <div class="wcdiv wcpage" style="width: 595.3pt; height: 841.9pt">
    <div
      class="wcdiv"
      style="
        left: 28.35pt;
        top: 818.9pt;
        clip: rect(0pt, 566.95pt, 24pt, -28.35pt);
      "
    >
      <span
        class="wcspan wctext004"
        style="
          font-size: 10pt;
          left: 266.8pt;
          top: 0.42pt;
          line-height: 11.07pt;
        "
        >3</span
      >
    </div>
    <div class="wcdiv" style="left: 28.35pt; top: 28.35pt">
      <span
        class="wcspan wctext001"
        style="font-size: 12.5pt; left: 0pt; top: 1.26pt; line-height: 14.99pt"
        >19.</span
      >
      <span
        class="wcspan wctext001"
        style="
          font-size: 12.5pt;
          left: 21.3pt;
          top: 1.26pt;
          line-height: 14.99pt;
        "
        >請問您知道拒檳榔菸酒可以預防口腔癌嗎？</span
      >
      <div class="wcdiv" style="left: 21.29pt; top: 16.25pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{
            ifq(
              "19.請問您知道拒檳榔菸酒可以預防口腔癌嗎？",
              "0.知道",
              "■",
              "□",
            )
          }}0.知道
          {{
            ifq(
              "19.請問您知道拒檳榔菸酒可以預防口腔癌嗎？",
              "1.不知道",
              "■",
              "□",
            )
          }}1.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 32.5pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >20.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 21.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >請問您知道政府有提供公費的肺癌篩檢服務嗎？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.29pt; top: 48.74pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{
            ifq(
              "20.請問您知道政府有提供公費的肺癌篩檢服務嗎？",
              "0.知道",
              "■",
              "□",
            )
          }}0.知道(續問20-1)
          {{
            ifq(
              "20.請問您知道政府有提供公費的肺癌篩檢服務嗎？",
              "1.不知道",
              "■",
              "□",
            )
          }}1.不知道</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 64.99pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >20-1.您知道公費「肺癌篩檢」的申請條件嗎?</span
        >
      </div>
      <div class="wcdiv" style="left: 21.29pt; top: 81.24pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{
            ifq(
              "您知道公費「肺癌篩檢」的申請條件嗎?",
              "1.有肺癌家族史：女45-74歲、男50-74歲",
              "■",
              "□",
            )
          }}1.有肺癌家族史：女40-74歲、男45-74歲
          {{
            ifq(
              "您知道公費「肺癌篩檢」的申請條件嗎?",
              "2.50-74歲重度吸菸者",
              "■",
              "□",
            )
          }}2.50-74歲重度吸菸者</span
        >
      </div>
      <div class="wcdiv" style="left: 21.29pt; top: 97.49pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{
            ifq("您知道公費「肺癌篩檢」的申請條件嗎?", "3.以上皆是", "■", "□")
          }}3.以上皆是</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 243.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{
            ifq("您知道公費「肺癌篩檢」的申請條件嗎?", "4.不知道", "■", "□")
          }}4.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 113.74pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >21.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 24pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >下列食物那個不屬於全榖雜糧類?</span
        >
      </div>
      <div class="wcdiv" style="left: 21.29pt; top: 129.98pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
          {{ ifq("下列食物那個不屬於全榖雜糧類?", "0.蕃薯", "■", "□") }}
          0.蕃薯
          {{ ifq("下列食物那個不屬於全榖雜糧類?", "1.南瓜", "■", "□") }}
          1.南瓜
          {{ ifq("下列食物那個不屬於全榖雜糧類?", "2.紅豆", "■", "□") }}
          2.紅豆
          {{ ifq("下列食物那個不屬於全榖雜糧類?", "3.玉米筍", "■", "□") }}
          3.玉米筍
          {{ ifq("下列食物那個不屬於全榖雜糧類?", "4.不知道", "■", "□") }}
          4.不知道
        </span>
      </div>
      <div class="wcdiv" style="top: 146.23pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >22.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 21.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >您有使用過{{ $city.name }}長者社區資源整合運用平台嗎？{{
            ifq(
              "請問您有使用過" + $city.name + "長者社區資源整合運用平台嗎？",
              "0.沒有",
              "■",
              "□",
            )
          }}0.否
          {{
            ifq(
              "請問您有使用過" + $city.name + "長者社區資源整合運用平台嗎？",
              "1.是",
              "■",
              "□",
            )
          }}1.是</span
        >
      </div>
      <div class="wcdiv" style="top: 162.48pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >23.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 18pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
          (女性填答)當您用力咳嗽時，是否有漏尿情形?
          {{
            ifq("(女性填答)當您用力咳嗽時，是否有漏尿情形?", "否", "■", "□")
          }}0.否
          {{
            ifq("(女性填答)當您用力咳嗽時，是否有漏尿情形?", "是", "■", "□")
          }}1.是</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 368.36pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >(</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 374.72pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >建</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 387.33pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >議</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 399.95pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >可</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 412.56pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >練</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 425.18pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >習</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 437.79pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >骨</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 450.4pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >盆</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 463.02pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >運</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 475.63pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >動</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 488.25pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >或</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 500.86pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >洽</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 513.47pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >婦</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 526.09pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >產</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 21.3pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >科諮詢)</span
        >
      </div>
      <div class="wcdiv" style="top: 194.98pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >24.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 21.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >請問您有聽過代謝症候群嗎?
        </span>
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 211.22pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("請問您有聽過代謝症候群嗎?", "0.沒聽過", "■", "□") }}0.沒聽過
          {{
            ifq("請問您有聽過代謝症候群嗎?", "1.聽過但不太清楚", "■", "□")
          }}1.聽過但不太清楚
          {{
            ifq("請問您有聽過代謝症候群嗎?", "2.聽過且大概知道內容", "■", "□")
          }}2.聽過且大概知道內容
          {{
            ifq(
              "請問您有聽過代謝症候群嗎?",
              "3.非常清楚，能說出5項指標",
              "■",
              "□",
            )
          }}3.非常清楚，能說出5項指標</span
        >
      </div>
      <div class="wcdiv" style="top: 227.47pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >25.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 21.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >您知道5大警戒指標(血壓偏高</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 182.84pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >、</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 194.38pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >空腹血糖偏高</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 268.41pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >、</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 279.95pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >空腹三酸甘油酯偏高</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 391.49pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >、</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 403.03pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腹部肥胖</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 452.07pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >、</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 463.6pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >高密度脂蛋白</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 21.3pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >膽固醇偏低)，幾項超標即為代謝症候群？
          {{
            ifq(
              "您知道5大警戒指標(血壓偏高、空腹血糖偏高、空腹三酸甘油酯偏高、腹部肥胖、高密度脂蛋白膽固醇偏低)，幾項超標即為代謝症候群？",
              "0.2項",
              "■",
              "□",
            )
          }}0.2項
          {{
            ifq(
              "您知道5大警戒指標(血壓偏高、空腹血糖偏高、空腹三酸甘油酯偏高、腹部肥胖、高密度脂蛋白膽固醇偏低)，幾項超標即為代謝症候群？",
              "1.3項",
              "■",
              "□",
            )
          }}1.3項
          {{
            ifq(
              "您知道5大警戒指標(血壓偏高、空腹血糖偏高、空腹三酸甘油酯偏高、腹部肥胖、高密度脂蛋白膽固醇偏低)，幾項超標即為代謝症候群？",
              "2.4項",
              "■",
              "□",
            )
          }}2.4項
          {{
            ifq(
              "您知道5大警戒指標(血壓偏高、空腹血糖偏高、空腹三酸甘油酯偏高、腹部肥胖、高密度脂蛋白膽固醇偏低)，幾項超標即為代謝症候群？",
              "4.不知道",
              "■",
              "□",
            )
          }}4.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 259.97pt">
        <div
          class="wcdiv"
          style="
            left: -0.05pt;
            top: -0.05pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 63.95pt;
            top: -0.05pt;
            width: 15.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 79.95pt;
            top: -0.05pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 16pt; left: 0pt; top: 1.61pt; line-height: 19.19pt"
          >第三部份：個人病史</span
        >
      </div>
      <div class="wcdiv" style="left: 3.12pt; top: 280.77pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >疾</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 12.59pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 25.18pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >：</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 37.77pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "0.無", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 50.36pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >無</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 62.96pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 69.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "1.高血壓", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 81.89pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >高</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 94.48pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >血</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 107.07pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >壓</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 119.66pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 126pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "2.糖尿病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 138.59pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >糖</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 151.18pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >尿</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 163.77pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 176.37pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 182.71pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "3.高血脂症", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 195.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >高</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 207.89pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >血</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 220.48pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >脂</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 233.07pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >症</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 245.66pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 252pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "4.心臟病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 264.59pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >心</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 277.18pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >臟</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 289.78pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 302.37pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 308.71pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "5.腦中風", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 321.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腦</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 333.89pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >中</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 346.48pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >風</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 359.07pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 365.41pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "6.腎臟病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 378pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腎</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 390.59pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >臟</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 403.19pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.09pt;
            left: 415.78pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
          >{{ ifq("1.疾病：", "7.B型肝炎", "■", "□") }}B</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 434.71pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          ></span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 441.05pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >型</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 453.64pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >肝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 466.23pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >炎</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 478.82pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "8.C型肝炎", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 491.41pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >C</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 497.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >型</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 510.35pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >肝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 522.94pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >炎</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 37.88pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "9.精神疾病", "■", "□") }}精神疾病
          {{ ifq("1.疾病：", "10.痛風", "■", "□") }}痛風
          {{ ifq("1.疾病：", "11.骨質疏鬆", "■", "□") }}骨質疏鬆
          {{ ifq("1.疾病：", "12.結核病", "■", "□") }}結核病
          {{ ifq("1.疾病：", "13.氣喘", "■", "□") }}氣喘
          {{ ifq("1.疾病：", "14.慢性潰瘍結腸炎", "■", "□") }}慢性潰瘍結腸炎
          {{ ifq("1.疾病：", "15.尿路結石", "■", "□") }}尿路結石
        </span>
      </div>
      <div class="wcdiv" style="left: 39.12pt; top: 313.26pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{
            ifq("1.疾病：", "16.家族性大腸瘜肉症(FAP)", "■", "□")
          }}家族性大腸瘜肉症(FAP)
          {{ ifq("1.疾病：", "17.大腸直腸瘜肉", "■", "□") }}大腸直腸瘜肉
          {{
            ifq("1.疾病：", "18.大腸癌或遺傳性息肉", "■", "□")
          }}大腸癌或遺傳性息肉 {{ ifq("1.疾病：", "19.骨刺", "■", "□") }}骨刺
        </span>
      </div>
      <div class="wcdiv" style="left: 39.12pt; top: 329.51pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.疾病：", "20.其他神經疾病", "■", "□") }}其他神經疾病</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 110pt; top: -2px"
          >{{ ift("1-20.其他神經疾病名稱") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 87.5pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 175pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
          {{ ifq("1.疾病：", "21.癌症", "■", "□") }}癌症</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 240pt; top: -2px"
          >{{ ift("1-21.癌症名稱") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 218.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 293.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
          {{ ifq("1.疾病：", "22.其他", "■", "□") }}其他：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 370pt; top: -2px"
          >{{ ifqOther("1.疾病：", "22.其他") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 350pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 437.5pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 87.5pt;
            top: 13.47pt;
            width: 87.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 218.75pt;
            top: 13.47pt;
            width: 75pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 350pt;
            top: 13.47pt;
            width: 87.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="left: 3.12pt; top: 345.76pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >長期服藥：{{ ifq("2.長期服藥：", "0.無", "■", "□") }}無
          {{ ifq("2.長期服藥：", "1.有，病因：", "■", "□") }}有，病因：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 180.5pt; top: -2pt"
          >&nbsp;{{ ifqOther("2.長期服藥：", "1.有，病因：") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 168.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 256.25pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >。</span
        >
        <div
          class="wcdiv"
          style="
            left: 168.75pt;
            top: 13.47pt;
            width: 87.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="left: 3.12pt; top: 362.01pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >請問您最近1年內有無因高血壓、高血脂或糖尿病在醫療院所規律就診？{{
            ifq(
              "3.請問您最近1年內有無因高血壓、高血脂或糖尿病在醫療院所規律就診？",
              "0.無",
              "■",
              "□",
            )
          }}0.無
          {{
            ifq(
              "3.請問您最近1年內有無因高血壓、高血脂或糖尿病在醫療院所規律就診？",
              "1.有",
              "■",
              "□",
            )
          }}1.有。</span
        >
      </div>
      <div class="wcdiv" style="top: 378.25pt">
        <div
          class="wcdiv"
          style="
            left: -0.05pt;
            top: -0.05pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 63.95pt;
            top: -0.05pt;
            width: 15.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 79.95pt;
            top: -0.05pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 16pt; left: 0pt; top: 1.61pt; line-height: 19.19pt"
          >第四部份：家族病史</span
        >
      </div>
      <div class="wcdiv" style="top: 399.05pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >請問您的</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 12.5pt;
            left: 50pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >祖父母、外祖父母、父母、子女、兄弟姐妹</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 287.5pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >之中有沒有人得過下列疾病?
        </span>
        <div
          class="wcdiv"
          style="
            left: 50pt;
            top: 13.47pt;
            width: 237.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 415.3pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >慢</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 12.66pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >性</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 25.33pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >疾</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 37.99pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 50.65pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >部</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 63.31pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >分</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 75.98pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >：</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 88.64pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "0.無", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 101.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >無</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 113.97pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 120.38pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "1.高血壓", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 133.04pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >高</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 145.71pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >血</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 158.37pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >壓</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 171.03pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 177.45pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "2.糖尿病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 190.11pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >糖</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 202.77pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >尿</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 215.43pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 228.1pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 234.51pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "3.血脂異常", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 247.17pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >血</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 259.84pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >脂</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 272.5pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >異</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 285.16pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >常</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 297.83pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 304.24pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "4.心臟病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 316.9pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >心</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 329.56pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >臟</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 342.23pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 354.89pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 361.3pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "5.腦中風", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 373.97pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腦</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 386.63pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >中</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 399.29pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >風</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 411.96pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 418.37pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "6.精神疾病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 431.03pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >精</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 443.69pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >神</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 456.36pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >疾</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 469.02pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.16pt;
            left: 481.68pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 488.1pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "7.腎臟病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 500.76pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腎</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 513.42pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >臟</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 526.09pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 538.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 92.13pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "8.癲癇", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 104.7pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癲</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 117.27pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癇</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.07pt;
            left: 129.84pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
          {{ ifq("1.慢性疾病部分：", "9.B/C型肝炎帶原", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 148.74pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >B/C</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 172.56pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >型</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 185.14pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >肝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 197.71pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >炎</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 210.28pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >帶</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 222.86pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >原</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.07pt;
            left: 235.43pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 236.75pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "10.慢性肝炎/肝硬化", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 249.32pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >慢</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 261.9pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >性</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 274.47pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >肝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 287.04pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >炎</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 299.62pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >/</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 305.94pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >肝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 318.51pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >硬</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 331.09pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >化</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.07pt;
            left: 343.66pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 349.98pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "11.攝護腺肥大", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 362.55pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >攝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 375.13pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >護</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 387.7pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >腺</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 400.27pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >肥</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 412.85pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >大</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.07pt;
            left: 425.42pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 431.74pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "12.痛風", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 444.32pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >痛</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 456.89pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >風</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.07pt;
            left: 469.46pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 475.78pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "13.巴金森氏症", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 488.36pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >巴</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 500.93pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >金</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 513.5pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >森</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 526.08pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >氏</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.6pt;
            left: 92.13pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >症
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 114.07pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "14.結核病", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 128.17pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >結</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 142.26pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >核</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 156.36pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.6pt;
            left: 170.46pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 178.3pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "15.氣喘", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 192.4pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >氣</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 206.5pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >喘</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.6pt;
            left: 220.6pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 228.44pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "16.大腸直腸瘜肉", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 242.54pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >大</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 256.64pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >腸</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 270.73pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >直</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 284.83pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >腸</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 298.93pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >瘜</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 313.02pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >肉</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.6pt;
            left: 327.12pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 334.97pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "17.家族性大腸瘜肉症", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 349.07pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >家</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 363.16pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >族</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 377.26pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >性</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 391.36pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >大</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 405.45pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >腸</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 419.55pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >瘜</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 433.65pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >肉</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 447.74pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >症</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.6pt;
            left: 461.84pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 469.69pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "18.尿路結石", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 483.79pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >尿</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 497.88pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >路</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 511.98pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >結</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 526.08pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >石</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 540.17pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 92.13pt;
            top: 50pt;
            line-height: 14.99pt;
          "
          >{{ ifq("1.慢性疾病部分：", "19.其他", "■", "□") }}其他：
          {{ ifqOther("1.慢性疾病部分：", "19.其他") }}</span
        >
        <div
          class="wcdiv"
          style="
            left: 143.75pt;
            top: 63.47pt;
            width: 87.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 480.29pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 12.8pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >症</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 25.61pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >部</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 38.41pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >分</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 51.21pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >：</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 64.02pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "0.無", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 76.82pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >無</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 89.62pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 96.17pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "1.子宮頸癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 108.98pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >子</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 121.78pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >宮</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 134.58pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >頸</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 147.39pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 160.19pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 166.74pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "2.乳癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 179.55pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >乳</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 192.35pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 205.15pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 211.7pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "3.肝癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 224.51pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >肝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 237.31pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 250.11pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 256.67pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "4.肺癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 269.47pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >肺</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 282.27pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 295.08pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 301.63pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "5.大腸直腸癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 314.43pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >大</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 327.23pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腸</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 340.04pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >直</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 352.84pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腸</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 365.64pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 378.45pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 385pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "6.胃癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 397.8pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >胃</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 410.61pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 423.41pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 429.96pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "7.口腔癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 442.76pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >口</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 455.57pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腔</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 468.37pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 0.3pt;
            left: 481.17pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 487.73pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "8.攝護腺癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 500.53pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >攝</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 513.33pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >護</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 526.14pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >腺</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 538.94pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 68.13pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "9.胰臟癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 82.46pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >胰</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 96.8pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >臟</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 111.13pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.84pt;
            left: 125.47pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 133.56pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "10.膽囊癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 147.89pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >膽</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 162.23pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >囊</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 176.56pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.84pt;
            left: 190.9pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 198.99pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "11.卵巢癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 213.32pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >卵</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 227.66pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >巢</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 241.99pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.84pt;
            left: 256.33pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 264.42pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "12.鼻咽癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 278.75pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >鼻</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 293.09pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >咽</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 307.42pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.84pt;
            left: 321.76pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 329.85pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "13.食道癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 344.18pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >食</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 358.52pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >道</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 372.85pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            letter-spacing: 1.84pt;
            left: 387.19pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 395.28pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "14.骨癌", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 409.61pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >骨</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 423.95pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 438.28pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >{{ ifq("2.癌症部分：", "15.白血病(血癌)", "■", "□") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 452.62pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >白</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 466.96pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >血</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 481.29pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >病</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 495.63pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >(</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 503.71pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >血</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 518.05pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >癌</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 532.39pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
          >)</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 538.64pt;
            top: 17.51pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 68.13pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
          >{{
            ifq("2.癌症部分：", "16.遺傳性非瘜肉大腸直腸癌", "■", "□")
          }}遺傳性非瘜肉大腸直腸癌
          {{ ifq("2.癌症部分：", "17.其他癌症", "■", "□") }}其他癌症</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 300.35pt; top: 31pt"
          >&nbsp;{{ ifqOther("2.癌症部分：", "17.其他癌症") }}</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 286.88pt;
            top: 33.75pt;
            line-height: 14.99pt;
          "
        >
        </span>
        <div
          class="wcdiv"
          style="
            left: 286.88pt;
            top: 45.96pt;
            width: 112.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="top: 529.03pt">
        <div
          class="wcdiv"
          style="
            left: -0.05pt;
            top: 8.95pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 63.95pt;
            top: 8.95pt;
            width: 15.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 79.95pt;
            top: 8.95pt;
            width: 95.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 16pt; left: 0pt; top: 10.61pt; line-height: 19.19pt"
          >第五部分：簡式健康量表</span
        >
      </div>
      <div class="wcdiv" style="top: 558.83pt">
        <span
          class="wcspan wctext002"
          style="left: 0pt; top: 1.21pt; line-height: 14.39pt"
          >說明</span
        >
        <span
          class="wcspan wctext002"
          style="left: 23.43pt; top: 1.21pt; line-height: 14.39pt"
          >：</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 34.87pt;
            top: 2.21pt;
            line-height: 13.19pt;
          "
          >本量表所列舉的問題是為協助您瞭解您的身心適應狀況</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 298.3pt;
            top: 2.21pt;
            line-height: 13.19pt;
          "
          >，</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 308.74pt;
            top: 2.21pt;
            line-height: 13.19pt;
          "
          >請您仔細回想</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 11pt;
            left: 374.74pt;
            top: 2.21pt;
            line-height: 13.19pt;
          "
          >在最近一星期中(包括今天)</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 506.17pt;
            top: 2.21pt;
            line-height: 13.19pt;
          "
          >，</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 516.6pt;
            top: 2.21pt;
            line-height: 13.19pt;
          "
          >這些</span
        >
        <div
          class="wcdiv"
          style="
            left: 374.74pt;
            top: 12.95pt;
            width: 131.43pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 35.45pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >問題使您感到困擾或苦惱的程度</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 188.74pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >，</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 199.03pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >然後</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 11pt;
            left: 221.03pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >圈選</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 243.03pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >一個您認為最能代表您感覺的答案</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 407.31pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >。</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 417.6pt;
            top: 16.7pt;
            line-height: 13.19pt;
          "
          >本資料僅提供心理衛生人</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 11pt;
            left: 35.45pt;
            top: 31pt;
            line-height: 13.19pt;
          "
          >員協助您的參考，資料絕對守密，請安心填寫。</span
        >
      </div>
      <div class="wcdiv" style="top: 603.03pt">
        <div
          class="wcdiv"
          style="
            left: 292.45pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 318.45pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 344.45pt;
            top: -0.05pt;
            width: 12.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 357.45pt;
            top: -0.05pt;
            width: 32.4pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 389.95pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 415.95pt;
            top: -0.05pt;
            width: 32.4pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 448.45pt;
            top: -0.05pt;
            width: 12.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 461.45pt;
            top: -0.05pt;
            width: 38.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 500.45pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 292.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >完全</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 318.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 344.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >輕</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 357.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 390pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >中等</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 416pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 448.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >厲</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 461.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 500.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >非常</span
        >
      </div>
      <div class="wcdiv" style="top: 619.92pt">
        <div
          class="wcdiv"
          style="
            left: 292.45pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 318.45pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 344.45pt;
            top: -0.05pt;
            width: 12.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 357.45pt;
            top: -0.05pt;
            width: 32.4pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 389.95pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 415.95pt;
            top: -0.05pt;
            width: 32.4pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 448.45pt;
            top: -0.05pt;
            width: 12.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 461.45pt;
            top: -0.05pt;
            width: 38.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 500.45pt;
            top: -0.05pt;
            width: 25.9pt;
            height: 16.8pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 292.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >沒有</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 318.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 344.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >微</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 357.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 390pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >程度</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 416pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 448.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >害</span
        >
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 461.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext002"
          style="
            font-size: 13pt;
            left: 500.5pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >厲害</span
        >
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 14.01pt;
            width: 526.5pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
      <div class="wcdiv" style="left: 13.9pt; top: 636.82pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 3.9pt; line-height: 15.59pt"
          >1.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 17.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >感覺緊張不安&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;{{
            ifq("1.感覺緊張不安", "完全沒有", "■", "□")
          }}.0</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 303.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 329.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("1.感覺緊張不安", "輕微", "■", "□") }}.1</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 355.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 381.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("1.感覺緊張不安", "中等程度", "■", "□") }}.2</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 407.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 433.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("1.感覺緊張不安", "厲害", "■", "□") }}.3</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 459.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 485.85pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("1.感覺緊張不安", "非常厲害", "■", "□") }}.4</span
        >
      </div>
      <div class="wcdiv" style="left: 14pt; top: 653.72pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 3.9pt; line-height: 15.59pt"
          >2.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >覺得容易苦惱或動怒&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;{{
            ifq("2.覺得容易苦惱或動怒", "完全沒有", "■", "□")
          }}.0</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 304pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 330pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("2.覺得容易苦惱或動怒", "輕微", "■", "□") }}.1</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 356pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 382pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("2.覺得容易苦惱或動怒", "中等程度", "■", "□") }}.2</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 408pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("2.覺得容易苦惱或動怒", "厲害", "■", "□") }}.3</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 460pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 486pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("2.覺得容易苦惱或動怒", "非常厲害", "■", "□") }}.4</span
        >
      </div>
      <div class="wcdiv" style="left: 14pt; top: 670.61pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 3.9pt; line-height: 15.59pt"
          >3.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >感覺憂鬱、心情低落&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;{{
            ifq("3.感覺憂鬱、心情低落", "完全沒有", "■", "□")
          }}.0</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 304pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 330pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("3.感覺憂鬱、心情低落", "輕微", "■", "□") }}.1</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 356pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 382pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("3.感覺憂鬱、心情低落", "中等程度", "■", "□") }}.2</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 408pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("3.感覺憂鬱、心情低落", "厲害", "■", "□") }}.3</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 460pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 486pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("3.感覺憂鬱、心情低落", "非常厲害", "■", "□") }}.4</span
        >
      </div>
      <div class="wcdiv" style="left: 14pt; top: 687.51pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 3.9pt; line-height: 15.59pt"
          >4.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >覺得比不上別人&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;{{
            ifq("4.覺得比不上別人", "完全沒有", "■", "□")
          }}.0</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 304pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 330pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("4.覺得比不上別人", "輕微", "■", "□") }}.1</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 356pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 382pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("4.覺得比不上別人", "中等程度", "■", "□") }}.2</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 408pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("4.覺得比不上別人", "厲害", "■", "□") }}.3</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 460pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 486pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{ ifq("4.覺得比不上別人", "非常厲害", "■", "□") }}.4</span
        >
      </div>
      <div class="wcdiv" style="left: 14pt; top: 704.41pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 3.9pt; line-height: 15.59pt"
          >5.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 18pt; top: 1.31pt; line-height: 15.59pt"
          >睡眠困難，譬如難以入睡、易醒或早醒&hellip;&hellip;&hellip;{{
            ifq("5.睡眠困難，譬如難以入睡、易醒或早醒", "完全沒有", "■", "□")
          }}.0</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 304pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 330pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.睡眠困難，譬如難以入睡、易醒或早醒", "輕微", "■", "□")
          }}.1</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 356pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 382pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.睡眠困難，譬如難以入睡、易醒或早醒", "中等程度", "■", "□")
          }}.2</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 408pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.睡眠困難，譬如難以入睡、易醒或早醒", "厲害", "■", "□")
          }}.3</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 460pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 486pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("5.睡眠困難，譬如難以入睡、易醒或早醒", "非常厲害", "■", "□")
          }}.4</span
        >
      </div>
      <div class="wcdiv" style="left: 6.5pt; top: 721.3pt">
        <span
          class="wcspan wctext002"
          style="font-size: 13pt; left: 0pt; top: 4.91pt; line-height: 15.59pt"
          >＊</span
        >
        <span
          class="wcspan wctext002"
          style="font-size: 13pt; left: 13pt; top: 4.91pt; line-height: 15.59pt"
        >
        </span>
        <span
          class="wcspan wctext002"
          style="font-size: 13pt; left: 26pt; top: 4.91pt; line-height: 15.59pt"
          >有自殺的想法(本題不計分)</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 182pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
          >&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;{{
            ifq("＊  有自殺的想法(本題不計分)", "完全沒有", "■", "□")
          }}.0</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 312pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 338pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
          >{{ ifq("＊  有自殺的想法(本題不計分)", "輕微", "■", "□") }}.1</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 364pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 390pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("＊  有自殺的想法(本題不計分)", "中等程度", "■", "□")
          }}.2</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 416pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 442pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
          >{{ ifq("＊  有自殺的想法(本題不計分)", "厲害", "■", "□") }}.3</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 468pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 494pt;
            top: 4.91pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("＊  有自殺的想法(本題不計分)", "非常厲害", "■", "□")
          }}.4</span
        >
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 23.61pt;
            width: 520pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          &nbsp;
        </div>
      </div>
    </div>
    <div class="wcdiv">
      <img
        class="wcimg"
        style="left: 451.5pt; top: 158.63pt; width: 33pt; height: 33pt"
        src="https://myfiles.space/user_files/136203_8f8e61a5d9d46e28/1768353884_2026-/1768353884_2026--3.png"
      />
    </div>
  </div>
</template>

<script>
import MixinBigQuiz from "@/mixins/bigQuiz";
import "@/assets/bigQuiz.scss";
export default {
  mixins: [MixinBigQuiz],
};
</script>
<style scoped lang="scss">
.q20-1 {
  margin-top: 44px;
  position: relative;
}
.cornerNote {
  position: relative;
  top: 920px;
  left: 500px;
}
</style>
